angular.module('webremote.directive.onDemand', ['webremote.module.ondemand'])

require('./onDemandJobPool/itemOverview/controller')
